import { useQuery } from '@tanstack/react-query';
import fetchSuggestedArticle from 'app/services/suggestedArticle';

import useFetchHelpCenter from './useFetchHelpCenter';

export default function useFetchSuggestedArticle({ enableSuggestedArticle }: { enableSuggestedArticle: boolean }) {
  const { data: helpCenter } = useFetchHelpCenter();

  return useQuery({
    queryKey: ['suggestedArticle', helpCenter?.uuid],
    queryFn: () =>
      fetchSuggestedArticle({
        uuid: helpCenter?.uuid,
      }),
    enabled: enableSuggestedArticle,
  });
}
